/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'yurstrap';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    disabled: PropTypes.bool,
    type: PropTypes.oneOf(['edit', 'delete', 'export', 'refresh']),
};

const defaultProps = {
    ...commonDefaultProps,
    disabled: false,
    type: 'delete',
};

const IconAction = (props) => {
    const classNames = [
        's-iconaction',
        ['edit', 'export', 'refresh'].indexOf(props.type) > -1
            ? 's-iconaction_edit'
            : '',
        props.type === 'delete' ? 's-iconaction_delete' : '',
        props.disabled ? 's-iconaction_disabled' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    let icon = null;
    switch (props.type) {
        case 'edit':
            icon = 'pencil';
            break;
        case 'export':
            icon = 'download';
            break;
        case 'refresh':
            icon = 'refresh';
            break;
        default:
            icon = 'times';
    }
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            <Icon icon={icon} className="s-iconaction__icon" />
        </props.componentClass>
    );
};

IconAction.propTypes = propTypes;

IconAction.defaultProps = defaultProps;

export default IconAction;
